import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@detco/my-ibe-icons/dist';
import { addDays, format, parse } from 'date-fns';
import { useMemo } from 'react';
const ISO_DATE_FORMAT = 'yyyy-MM-dd';
const WEEK_DAY_LABEL = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
];
const createDayArray = (startDate, endDate) => () => {
    const days = {};
    let date = parse(startDate, ISO_DATE_FORMAT, 0);
    const end = parse(endDate, ISO_DATE_FORMAT, 0);
    while (date <= end) {
        const dt = format(date, ISO_DATE_FORMAT);
        days[dt] = date.getDay();
        date = addDays(date, 1);
    }
    return days;
};
export const MyIbeCalendarNav = (props) => {
    const { dateFrom, dateEnd, translation, onChange } = props;
    const formatOptions = { locale: translation.locale };
    const today = format(new Date(), ISO_DATE_FORMAT);
    const disablePrev = (dateFrom <= today);
    const fromAsDate = parse(dateFrom, ISO_DATE_FORMAT, 0);
    const endAsDate = parse(dateEnd, ISO_DATE_FORMAT, 0);
    const labelFrom = format(fromAsDate, translation.displayDateFormat, formatOptions);
    const labelTill = format(endAsDate, translation.displayDateFormat, formatOptions);
    const changeFromDate = (days) => {
        const date = format(addDays(parse(dateFrom, ISO_DATE_FORMAT, 0), days), ISO_DATE_FORMAT);
        onChange((date < today) ? today : date);
    };
    const dates = useMemo(createDayArray(dateFrom, dateEnd), [dateFrom, dateEnd]);
    return (_jsxs("div", { className: "ibe-calendar-nav", children: [_jsxs("div", { className: "ibe-calendar-navigation", children: [_jsxs("button", { className: "previous-week", onClick: () => changeFromDate(-7), disabled: disablePrev, children: [_jsx(Icon, { icon: "chevron-left", size: 16 }), _jsx(Icon, { icon: "chevron-left", size: 16 })] }), _jsx("button", { className: "previous-day", onClick: () => changeFromDate(-1), disabled: disablePrev, children: _jsx(Icon, { icon: "chevron-left", size: 16 }) }), _jsxs("span", { className: "ibe-calendar-date", children: [labelFrom, " - ", labelTill] }), _jsx("button", { className: "next-day", onClick: () => changeFromDate(1), children: _jsx(Icon, { icon: "chevron-right", size: 16 }) }), _jsxs("button", { className: "next-week", onClick: () => changeFromDate(7), children: [_jsx(Icon, { icon: "chevron-right", size: 16 }), _jsx(Icon, { icon: "chevron-right", size: 16 })] })] }), _jsx("div", { className: "ibe-calendar-header ibe-property-view", children: Object.entries(dates).map(([date, weekDay]) => {
                    const dayName = WEEK_DAY_LABEL[weekDay];
                    return (_jsx("span", { children: translation.dayLabel[dayName] }, date));
                }) })] }));
};
//# sourceMappingURL=MyIbeCalendarNav.js.map